import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const runTransactionWithRetry = async <T>(
  editorSdkProxy: EditorSDK,
  transaction: () => T,
): Promise<T> => {
  try {
    return await editorSdkProxy.document.transactions.runAndWaitForApproval(
      transaction,
    )
  } catch (error: any) {
    const isConflictError =
      await editorSdkProxy.document.transactions.isConflictError(error)
    if (isConflictError) {
      return await editorSdkProxy.document.transactions.runAndWaitForApproval(
        transaction,
      )
    } else {
      throw new Error('EditorSDK transaction failed', { cause: error })
    }
  }
}
